import api from './api';

const taskService = {
  getAll: async (params = {}) => {
    const response = await api.get('/tasks', { params });
    return response.data;
  },

  getMyTasks: async () => {
    const response = await api.get('/tasks/my-tasks');
    return response.data;
  },

  getOverdue: async () => {
    const response = await api.get('/tasks/overdue');
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/tasks/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await api.post('/tasks', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/tasks/${id}`, data);
    return response.data;
  },

  updateStatus: async (id, status) => {
    const response = await api.patch(`/tasks/${id}/status`, null, {
      params: { status }
    });
    return response.data;
  },
  
  getSubtasks: async (taskId) => {
    const response = await api.get(`/tasks/${taskId}/subtasks`);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/tasks/${id}`);
    return response.data;
  },

  // KI-Aufgabenassistenz
  aiAssist: async (data) => {
    const response = await api.post('/tasks/ai-assist', data);
    return response.data;
  },

  // PDF-Export der Aufgabenliste
  exportPdf: async (params = {}) => {
    const response = await api.get('/tasks/export-pdf', {
      params,
      responseType: 'blob'
    });
    return response.data;
  },

  // PDF-Export einer einzelnen Aufgabe
  exportSinglePdf: async (id) => {
    const response = await api.get(`/tasks/${id}/export-pdf`, {
      responseType: 'blob'
    });
    return response.data;
  },

  // Reihenfolge aktualisieren
  reorder: async (taskIds) => {
    const response = await api.put('/tasks/reorder', { task_ids: taskIds });
    return response.data;
  },

  // ───────────────── Multi-Select & Bulk ─────────────────
  bulkAction: async (taskIds, action, value = null) => {
    const response = await api.post('/tasks/bulk', { task_ids: taskIds, action, value });
    return response.data;
  },

  // ───────────────── Recurring ─────────────────
  setRecurrence: async (id, payload) => {
    const response = await api.patch(`/tasks/${id}/recurrence`, payload);
    return response.data;
  },

  // ───────────────── My Inbox ─────────────────
  getInbox: async (limit = 50) => {
    const response = await api.get('/tasks/inbox/me', { params: { limit } });
    return response.data;
  },

  // ───────────────── Templates ─────────────────
  templates: {
    list: async () => {
      const r = await api.get('/task-templates');
      return r.data;
    },
    create: async (payload) => {
      const r = await api.post('/task-templates', payload);
      return r.data;
    },
    delete: async (id) => {
      const r = await api.delete(`/task-templates/${id}`);
      return r.data;
    },
    apply: async (id, ctx = {}) => {
      // ctx kann project_id/address_id/order_id enthalten
      const r = await api.post(`/task-templates/${id}/apply`, null, { params: ctx });
      return r.data;
    },
  },
};

export default taskService;
